import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import { navigate } from "gatsby"

import "bootstrap/dist/css/bootstrap.css"
import "./model.css"

import image1 from "../../../../static/images/images/logo.svg"
import image2 from "../../../../static/images/images/close.svg"

export default function Model() {
  const [show, setShow] = useState(false)

  const handleShow = () => setShow(true)
  const handleClose = () => setShow(false)
  const handlhideShow = () => setShow(false)
  const continueBtn = () => {
    navigate("/")
  }
  return (
    <>
      <div>
        <button className="btn btnclose" onClick={handleShow} type="button">
          Cancel Enrollment
        </button>
      </div>
      <Modal className="ctm-modal" onHide={handleClose} show={show}>
        <div className="modal-header bgYellow">
          <h5 className="modal-title">
            <img alt="" className="img-fluid" src={image1} />
          </h5>
          <a
            className="close-img"
            data-bs-dismiss="modal"
            onClick={handlhideShow}
          >
            <img alt="Close" className="img-fluid" src={image2} />
          </a>
        </div>
        <div className="modal-body">
          <div className="section-heading">
            <h2>Cancel Enrollment</h2>
          </div>
          <div className="content">
            <p>
              {" "}
              If you leave, you will lose all of your progress. Are you sure?
            </p>
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="btn btnclose"
            data-bs-dismiss="modal"
            onClick={handlhideShow}
            type="button"
          >
            No, continue enrollment
          </button>
          <button
            className="btn btn-yellow"
            data-bs-dismiss="modal"
            onClick={continueBtn}
            type="button"
          >
            Yes, cancel enrollment
          </button>
        </div>
      </Modal>
    </>
  )
}
